import axios from 'axios';

const TRIP_PLANNER_API_BASE_URL = 'http://localhost:5000/api';

const tripPlannerApi = axios.create({
  baseURL: TRIP_PLANNER_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

tripPlannerApi.interceptors.response.use(
  (response) => response?.data
);

export { tripPlannerApi };